import { h } from 'preact';
import register from '@wcd/preact-custom-element';
import { TESCookieV2 } from '../shared/cookies';

const CONFIRMATION_TEXT = "Are you sure you want to delete this reply?";

export const component = ({ 'reply-id': replyId, 'resource-author-id': resourceAuthorId }) => {

  const { userId } = TESCookieV2() || {};

  const isResourceOwner = Number(userId) === Number(resourceAuthorId);

  const replyBlock = document.getElementById(`rdp-review-reply-item-${replyId}`);

  const deleteReply = async (event) => {
    event.stopPropagation();

    if (!confirm(CONFIRMATION_TEXT)) {
      return;
    }
    fetch(`/api/review/reply/${replyId}`, {
      method: 'DELETE',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    }).then((response) => {
      if (!response.ok) throw Error(response.statusText);
      return response;
    }).then(() => replyBlock?.remove());

  };

  if (!isResourceOwner) {
    return null;
  }

  return (
    <div>
      <div className='rdp-review-reply__remove'>
        <a title='Remove this reply' className='rdp-review-reply__remove-link' onClick={deleteReply}>
          remove
        </a>
      </div>
    </div>
  );
};

register(component, 'reply-author-buttons', [], { shadow: false });

